import cx from 'classnames';
import VehicleMakeIcon from '@/common/VehicleMakeIcon';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import getWhyBuyPlaceholderLabel from '~/utilities/vdp/getWhyBuyPlaceholderLabel';
import { Label, Placeholder } from './WhyBuyMakePlaceholder.styles';

type Variant = 'card' | 'modal';

type OwnProps = {
  bulletType?: string;
  variant?: Variant;
};

const VARIANTS: Record<
  Variant,
  { gap: string; label: string; logo?: string; logoSize: number }
> = {
  card: { gap: 'gap-sm', label: 't-label-sm', logoSize: 53 },
  modal: {
    gap: 'gap-md',
    label: 't-label-md md:text-[28px] md:leading-[2rem]',
    logo: 'size-[60px] md:size-[104px]',
    logoSize: 60
  }
};

export default function WhyBuyMakePlaceholder({
  bulletType,
  variant = 'card'
}: OwnProps) {
  const { make } = useGetVehicleDetails();
  const { gap, label, logo, logoSize } = VARIANTS[variant];

  return (
    <Placeholder className={gap} data-testid="why-buy-media-placeholder">
      <VehicleMakeIcon
        aria-hidden
        className={cx('grayscale opacity-40', logo)}
        data-testid="why-buy-make-logo"
        make={make}
        size={logoSize}
      />
      <Label className={label}>{getWhyBuyPlaceholderLabel(bulletType)}</Label>
    </Placeholder>
  );
}
